import { useApiUrl } from '@gemini/lux-ds-pms';
import { OBRoutes } from '@utils/apiRoutes';
import { MasterLookUpDTO } from '@utils/interfaces';
import { useOBQuery } from '@hooks/useOBQuery';
import { useOnlineBookingStore } from '@store/onlineBookingStore';

export interface GenderRequest {
  organizationId: string | undefined;
}

const useGetGenderList = ({ organizationId }: GenderRequest) => {
  const brandName = useOnlineBookingStore(state => state.brandName);

  const url = useApiUrl(
    OBRoutes.MasterLookUpGender,
    'ONLINEBOOKING_CLIENT_BFF_API_BASE_URL',
  )?.replace('##organizationId', organizationId || '');

  return useOBQuery<MasterLookUpDTO>(url, {
    enabled: !!url && !!organizationId && !brandName,
    staleTime: 600000,
  });
};

export default useGetGenderList;
